import type { LocaleIso } from "@solvari/translations";

export const zipcodeRegex = Object.freeze({
  "nl-NL": /^[1-9][0-9]{3}\s?(?!sa|sd|ss)[a-z]{2}$/i,
  "nl-NL_partial": /^[1-9][0-9]{0,3}\s?(?!sa|sd|ss)[a-z]{0,2}$/i,
  "nl-BE": /^[1-9][0-9]{3}$/,
  "nl-BE_partial": /^[1-9][0-9]{0,3}$/,
  "fr-BE": /^[1-9][0-9]{3}$/,
  "fr-BE_partial": /^[1-9][0-9]{0,3}$/,
  "fr-FR": /^[1-9][0-9]{4}$/,
  "fr-FR_partial": /^[1-9][0-9]{0,4}$/,
  "sv-SE": /^[0-9]{3}\s?[0-9]{2}$/,
  "sv-SE_partial": /^[0-9]{3}\s?[0-9]{2}$/,
  "da-DK": /^[0-9]{4}$/,
  "da-DK_partial": /^[0-9]{0,4}$/,
} satisfies Record<LocaleIso | `${LocaleIso}_partial`, RegExp>);
